export default "__VITE_ASSET__CPt51Zxr__"